import { Heart, Shield, Clock } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { useT } from "@/lib/i18n";

const SesionReasons = () => {
  const t = useT();
  const reasons = [
    { icon: Heart, title: t("free.reason1.t"), desc: t("free.reason1.d") },
    { icon: Shield, title: t("free.reason2.t"), desc: t("free.reason2.d") },
    { icon: Clock, title: t("free.reason3.t"), desc: t("free.reason3.d") },
  ];

  return (
    <section className="py-20 md:py-28 bg-sand/30 grain">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <Reveal className="max-w-2xl mb-14">
          <p className="text-[11px] tracking-[0.32em] uppercase text-sage mb-5">{t("free.what.eyebrow")}</p>
          <h2 className="font-serif text-4xl md:text-5xl text-charcoal leading-[1.05]">
            {t("free.what.title1")} <span className="italic">{t("free.what.title2")}</span>.
          </h2>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          {reasons.map((r, i) => (
            <Reveal key={r.title} delay={i * 0.08}>
              <article className="bg-ivory rounded-3xl p-8 md:p-10 border border-sand/60 h-full">
                <span className="w-12 h-12 rounded-full bg-sand flex items-center justify-center text-olive">
                  <r.icon size={20} />
                </span>
                <h3 className="mt-6 font-serif text-2xl md:text-3xl text-charcoal">{r.title}</h3>
                <p className="mt-3 text-charcoal/65 text-[15px] leading-relaxed">{r.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SesionReasons;
